<div
  class="grid grid-cols-1 gap-4 lg:grid-cols-6 auto-rows-max lg:gap-4 px-6 mb-4">
  <div
    class="rounded-xl bg-[var(--mat-sys-surface-container-lowest)] border border-[var(--mat-sys-outline-variant)] p-4 sm:p-6 lg:p-8 h-72">
    <ul class="mt-6 space-y-1">
      <li>
        <a
          routerLink="/usuario"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: true }"
          #rla_profile="routerLinkActive"
          class="block text-base font-normal transition duration-150 ease-in rounded-xl px-4 py-2"
          [ngClass]="{
            menuItemBaseSyle: true,
            'bg-[var(--mat-sys-secondary)] text-[var(--mat-sys-on-secondary)]':
              rla_profile.isActive,
            'text-[var(--mat-sys-on-surface)] hover:bg-[var(--mat-sys-secondary)] hover:text-[var(--mat-sys-on-secondary)] ':
              !rla_profile.isActive,
          }">
          Perfil
        </a>
      </li>

      <li>
        <a
          [routerLink]="'direcciones'"
          routerLinkActive
          [routerLinkActiveOptions]="linkActiveOptions"
          [routerLinkActiveOptions]="{ exact: false }"
          #rla_address="routerLinkActive"
          class="block text-base font-normal transition duration-150 ease-in rounded-xl px-4 py-2"
          [ngClass]="{
            'bg-[var(--mat-sys-secondary)] text-[var(--mat-sys-on-secondary)]':
              rla_address.isActive,
            'text-[var(--mat-sys-on-surface)] hover:bg-[var(--mat-sys-secondary)] hover:text-[var(--mat-sys-on-secondary)] ':
              !rla_address.isActive,
          }">
          Mis direcciones
        </a>
      </li>

      <li>
        <a
          [routerLink]="'ordenes/resumen'"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: true }"
          #rla_orders="routerLinkActive"
          class="block text-base font-normal transition duration-150 ease-in rounded-xl px-4 py-2"
          [ngClass]="{
            'bg-[var(--mat-sys-secondary)] text-[var(--mat-sys-on-secondary)]':
              rla_orders.isActive,
            'text-[var(--mat-sys-on-surface)] hover:bg-[var(--mat-sys-secondary)] hover:text-[var(--mat-sys-on-secondary)] ':
              !rla_orders.isActive,
          }">
          Mis Pedidos
        </a>
      </li>
    </ul>
  </div>
  <div
    class="rounded-xl bg-[var(--mat-sys-surface-container-lowest)] p-4 border border-[var(--mat-sys-outline-variant)] sm:p-6 lg:p-8 lg:col-span-5">
    <router-outlet></router-outlet>
  </div>
</div>
